export default __webpack_public_path__ + "static/media/ADIZ_01_mos_JLEE.820e4749.wav";